

<template>
  <v-dialog v-model="dialog" :max-width="options.width"  @keydown.esc="cancel">
    <v-card>
      <v-toolbar dark :color="options.color" dense flat>
        <v-toolbar-title class="white--text">{{ title }}</v-toolbar-title>
      </v-toolbar>
        <v-card-text v-show="!!message" class="pa-4">
            <div v-for="(text,index) in message.split('\n')" :key="index">
                {{ text }}
            </div>         
        </v-card-text>
      <v-card-actions class="pt-0">
        <v-spacer></v-spacer>
        <v-btn color="grey" text @click.native="cancel">閉じる</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
        data: () => ({
        name: "BulkRegistrationErrorDialog",
    dialog: false,
    resolve: null,
    reject: null,
    message: "",
    title: "",
    options: {
      color: "red",
      width: 500,
    }
  }),
  methods: {
    open(title, message, options) {
      this.dialog = true;
      this.title = title;
      this.message = message;
      this.options = Object.assign(this.options, options);
      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },
    cancel() {
      this.resolve(false);
      this.dialog = false;
    }
  }
};
</script>
<style>
</style>
